export default __webpack_public_path__ + "static/floating-video-43e12f19a14bafa3472d0999baa81e9e.png";